import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Layout from "../Components/common/Layout";
import AddFarmer from "../Components/farmer/AddFarmer";
import FarmerDetails from "../Components/farmer/FarmerDetails";
import Account from "../Pages/Account";
import Certificates from "../Pages/Certificates";
import Farmer from "../Pages/Farmer";
import Inventory from "../Pages/Inventory/Inventory";
import { InventoryList } from "../Pages/Inventory/InventoryList";
import Home from "../Pages/Home";
import MyDocuments from "../Pages/MyDocuments";
import Procurement from "../Pages/Procurement";
import Profile from "../Pages/Profile";
import { AuthRoute, PrivateRoute } from "./ProtectedRoute";
import ProcurementForm from "../Components/procurement/ProcurementForm";
import SignIn from "../Pages/SignIn";
import TcForm from "../Components/TransactionCertificates/TcForm";
import NonCertStock from "../Components/non-cert-stock/NonCertStock";
import AddNonCertStock from "../Components/non-cert-stock/AddNonCertStock";
import RegistrationCertificate from "../Pages/RegistrationCertificate";
import RegistrationCertificateDetails from "../Pages/ContractorDashboard/RCFormContractor";
import RegistrationCertificateExtensionDetails from "../Pages/ContractorDashboard/RCExtensionDetails.js";
import RegistrationCertificateCertifier from "../Pages/CertifierDashboard/RCcertifierDetails";
import RegistrationCertificatePlanner from "../Pages/PlannerDashboard/RCFormPlanner";
import RegistrationCertificateAuditor from "../Pages/AuditorDashboard/RegistrationCertificateAuditor";
import IncomingApplications from "../Pages/ContractorDashboard/IncomingApplications";
import AcceptedApplications from "../Pages/ContractorDashboard/AcceptedApplications";
import { IncomingShipmentList } from "../Pages/Shipments/IncomingShipmentList";
import { IncomingShipmentDetails } from "../Pages/Shipments/IncomingShipmentDetails";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import RejectedApplications from "../Pages/ContractorDashboard/RejectedApplications";
import IncomingApplication from "../Pages/PlannerDashboard/IncomingApplication";
import UpcomingAplications from "../Pages/AuditorDashboard/UpcomingAplications";
import AuditorRejectedApplications from "../Pages/AuditorDashboard/CancelledAudits";
import CertifierIncomingApplications from "../Pages/CertifierDashboard/IncomingApplications";
import CertifierAcceptedApplications from "../Pages/CertifierDashboard/AcceptedApplications";
import CertifierRejectedApplications from "../Pages/CertifierDashboard/RejectedApplications";
import CertifierPendingApplications from "../Pages/CertifierDashboard/PendingApplications";
import AssignedApplications from "../Pages/ContractorDashboard/AssignedApplications";
import AssignedApplicationPlanner from "../Pages/PlannerDashboard/AssignedApplications";
import CompletedApplications from "../Pages/PlannerDashboard/CompletedApplications";
import PendingApplication from "../Pages/PlannerDashboard/PendingApplications";
import AuditorCompletedApplications from "../Pages/AuditorDashboard/CompletedAudits";
import Contractor from "../Pages/Contractor";
import RCFormUploadDocuments from "../Pages/ContractorDashboard/RCFormUploadDocuments";
import Planner from "../Pages/Planner";
import Auditor from "../Pages/Auditor";
import Certifier from "../Pages/Certifier";
import RCFormPlanner from "../Pages/PlannerDashboard/RCFormPlanner";
import ResetPassword from "../Pages/ResetPassword";
import ErrorPage from "../Pages/ErrorPage";
import UserCreation from "../Pages/User-Creation/UserCreation";
import RC from "../Components/Certificates/RC";
import TC from "../Components/Certificates/TC";
import RCCertifierDetails from "../Pages/CertifierDashboard/RCcertifierDetails";
import TransactionL1Approver from "../Pages/TransactionCertificateAdmin/TCL1Approver/TransactionL1Approver";
import TransactionL2Approver from "../Pages/TransactionCertificateAdmin/TCL2Approver/TransactionL2Approver";
import ProcurementApproval from "../Pages/ProcurementApproval/ProcurementApproval";
import ProcurementApplicationDetails from "../Pages/ProcurementApproval/ApplicationDetails";
import InventoryDetails from "../Pages/Inventory/InventoryDetails";
import AppliedProcurements from "../Components/procurement/AppliedProcurements";
import TransactionCertificate from "../Pages/TransactionCertificate/TransactionCertificate";
import ClientTCDetails from "../Pages/TransactionCertificate/ClientTCDetails";
import TCL2Details from "../Pages/TransactionCertificateAdmin/TCL2Approver/TCL2Details";
import TCL1Details from "../Pages/TransactionCertificateAdmin/TCL1Approver/TCL1Details.js";
import OfflinePage from "../Pages/OfflinePage";
import UserCreationTable from "../Pages/User-Creation/UserCreationTable";
import ShowTraceDetails from "../Pages/TransactionCertificateAdmin/TCL2Approver/ShowTraceDetails";
import TCnew from "../Components/Certificates/TCnew";
import FullTrace from "../Pages/TransactionCertificateAdmin/TCL2Approver/FullTrace";
import TraceApp from "../Pages/traceability/TraceApp";
import HomePage from "../Pages/traceability/Pages/HomePage";
import FarmersDetails from "../Pages/traceability/Pages/FarmersDetails";
import DetailPage from "../Pages/traceability/Pages/DetailPage";
import Supplier from "../Pages/supplier/Supplier.js";
import SupplierDetails from "../Pages/supplier/SupplierDetails.js";
import AddSupplier from "../Pages/supplier/AddSupplier.js";
import AddThirdPartySupplier from "../Pages/ThirdPartySupplier/AddThirdPartySupplier.js";
import RCFormExtension from "../Pages/PlannerDashboard/RCFormExtension.js";
import RCFormRenewal from "../Pages/PlannerDashboard/RCFormRenewal.js";
import RCRenewCertifierDetails from "../Pages/CertifierDashboard/RCRenewCertifierDetails.js";
import RCExtensionCertifierDetails from "../Pages/CertifierDashboard/RCExtensionCertifierDetails.js";

function Routing() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/signin" element={<AuthRoute />}>
          <Route path="/signin" element={<SignIn />} />
        </Route>
        <Route path="/" element={<PrivateRoute />}>
          {/* homepage to go based on roles logic */}
          <Route exact path="/" element={<Navigate to={"/dashboard"} />} />
          <Route
            exact
            path="/dashboard"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            exact
            path="/supplier"
            element={
              <Layout>
                <Supplier />
              </Layout>
            }
          />
          <Route
            exact
            path="/supplier/third-party-supplier"
            element={
              <Layout>
                <AddThirdPartySupplier />
              </Layout>
            }
          />
          <Route
            exact
            path="/user-table/create"
            element={
              <Layout>
                <UserCreation />
              </Layout>
            }
          />

          <Route
            exact
            path="/user-table"
            element={
              <Layout>
                <UserCreationTable />
              </Layout>
            }
          />

          <Route
            exact
            path="/supplier/farmer-details/:id"
            element={
              <Layout>
                <FarmerDetails />
              </Layout>
            }
          />
          <Route
            exact
            path="/supplier/supplier-details/:id"
            element={
              <Layout>
                <SupplierDetails />
              </Layout>
            }
          />
          <Route
            exact
            path="/rc"
            element={
              <Layout>
                <RC />
              </Layout>
            }
          />

          <Route
            exact
            path="/supplier/add-farmer"
            element={
              <Layout>
                <AddFarmer />
              </Layout>
            }
          />
          <Route
            exact
            path="/procurement"
            element={
              <Layout>
                <AppliedProcurements />
              </Layout>
            }
          />
          <Route
            exact
            path="/procurement/details/:id"
            element={
              <Layout>
                <ProcurementApplicationDetails />
              </Layout>
            }
          />
          <Route
            exact
            path="/procurement/procurement-form"
            element={
              <Layout>
                <ProcurementForm />
              </Layout>
            }
          />

          <Route
            exact
            path="/inventory"
            element={
              <Layout>
                <Inventory />
              </Layout>
            }
          ></Route>
          <Route
            path="inventory/inventory-list/:unitId/:programId"
            element={
              <Layout>
                <InventoryList />
              </Layout>
            }
          />
          <Route
            path="inventory/inventory-list/:unitId/:programId/:id"
            element={
              <Layout>
                <InventoryDetails />
              </Layout>
            }
          />

          <Route
            exact
            path="client/transaction-certificates"
            element={
              <Layout>
                <TransactionCertificate />
              </Layout>
            }
          />
          <Route
            exact
            path="/client/transaction-certificates/tc-details/:id"
            element={
              <Layout>
                <ClientTCDetails />
              </Layout>
            }
          />

          <Route
            exact
            path="/client/transaction-certificates/tc-form"
            element={
              <Layout>
                <TcForm />
              </Layout>
            }
          />
          <Route
            path="/contractor/rc-form-details/:id"
            element={
              <Layout>
                <RegistrationCertificateDetails />
              </Layout>
            }
          />
          <Route
            path="/contractor/rc-form-extension-details/:id"
            element={
              <Layout>
                <RegistrationCertificateExtensionDetails />
              </Layout>
            }
          />
          <Route
            path="/planner/rc-form-planner/:id"
            element={
              <Layout>
                <RCFormPlanner />
              </Layout>
            }
          />
          <Route
            path="/planner/rc-form-planner/extension/:id"
            element={
              <Layout>
                <RCFormExtension />
              </Layout>
            }
          />
          <Route
            path="/planner/rc-form-planner/renew/:id"
            element={
              <Layout>
                <RCFormRenewal />
              </Layout>
            }
          />

          <Route
            path="/auditor/rc-form-details/:id"
            element={
              <Layout>
                <RegistrationCertificateAuditor />
              </Layout>
            }
          />
          <Route
            path="/contractor/rc-form-contractor/:id"
            element={
              <Layout>
                <RCFormUploadDocuments />
              </Layout>
            }
          />
          <Route
            path="/contractor"
            element={
              <Layout>
                <Contractor />
              </Layout>
            }
          />

          <Route
            path="/certifier"
            element={
              <Layout>
                <Certifier />
              </Layout>
            }
          />
          <Route
            path="/certifier/rc-form-certifier/:id"
            element={
              <Layout>
                <RCCertifierDetails />
              </Layout>
            }
          />
          <Route
            path="/certifier/rc-form-certifier-renew/:id"
            element={
              <Layout>
                <RCRenewCertifierDetails />
              </Layout>
            }
          />
          <Route
            path="/certifier/rc-form-certifier-extension/:id"
            element={
              <Layout>
                <RCExtensionCertifierDetails />
              </Layout>
            }
          />

          <Route
            path="/certifier/rc-form-certifier/preview/:id"
            element={<RC />}
          />

          <Route
            path="/planner"
            element={
              <Layout>
                <Planner />
              </Layout>
            }
          />

          <Route
            path="/auditor"
            element={
              <Layout>
                <Auditor />
              </Layout>
            }
          />

          <Route
            path="/certifier"
            element={
              <Layout>
                <Certifier />
              </Layout>
            }
          />

          <Route
            path="/certifier-dashboard-incoming-applications"
            element={<CertifierIncomingApplications />}
          />
          <Route
            path="/certifier-dashboard-accepted-applications"
            element={<CertifierAcceptedApplications />}
          />
          <Route
            path="/certifier-dashboard-rejected-applications"
            element={<CertifierRejectedApplications />}
          />
          <Route
            path="/certifier-dashboard-pending-applications"
            element={<CertifierPendingApplications />}
          />

          <Route
            path="/shipments"
            element={
              <Layout>
                <IncomingShipmentList />
              </Layout>
            }
          ></Route>
          <Route
            path="shipments/shipment-details"
            element={
              <Layout>
                <IncomingShipmentDetails />
              </Layout>
            }
          />
          {/* <Route
        exact
        path="/profile"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      >
        <Route
          exact
          path="/account"
          element={
            <Layout>
              <Profile>
                <Account />
              </Profile>
            </Layout>
          }
        />
        <Route
          exact
          path="/my-documents"
          element={
            <Layout>
              <Profile>
                <Account />
              </Profile>
            </Layout>
          }
        />
      </Route> */}
          {/* <Route
        exact
        path="/stocks"
        element={
          <Layout>
            <NonCertStock />
          </Layout>
        }
      /> */}
          <Route
            exact
            path="/stocks"
            element={
              <Layout>
                <AddNonCertStock />
              </Layout>
            }
          />
          <Route
            path="/profile"
            element={
              <Layout>
                <Profile />
              </Layout>
            }
          >
            <Route path="account" element={<Account />} />
            <Route path="my-documents" element={<MyDocuments />} />
          </Route>

          {/* admin routes */}

          <Route
            path="/approval-center"
            element={
              <Layout>
                <ProcurementApproval />
              </Layout>
            }
          ></Route>

          <Route
            path="/tc-l1-admin"
            element={
              <Layout>
                <TransactionL1Approver />
              </Layout>
            }
          ></Route>

          <Route
            path="/tc-l2-admin"
            element={
              <Layout>
                <TransactionL2Approver />
              </Layout>
            }
          ></Route>
          <Route
            path="/supplier/add-supplier"
            element={
              <Layout>
                <AddSupplier />
              </Layout>
            }
          ></Route>

          <Route
            path="tc-l1-admin/tc-details/:id"
            element={
              <Layout>
                <TCL1Details />
              </Layout>
            }
          ></Route>
          <Route
            path="tc-l2-admin/tc-details/:id"
            element={
              <Layout>
                <TCL2Details />
              </Layout>
            }
          ></Route>

          {/* <Route path="/preview-tc/:id" element={<TCnew />} /> */}
          <Route
            path="tc-l2-admin/tc-details/:id/showTrace/:tcNumber"
            element={
              <Layout>
                <ShowTraceDetails />
              </Layout>
            }
          ></Route>
          <Route
            path="tc-l2-admin/tc-details/:id/FullTrace/:tcNumber"
            element={
              <Layout>
                <FullTrace />
              </Layout>
            }
          ></Route>

          <Route
            path="approval-center/:id"
            element={
              <Layout>
                <ProcurementApplicationDetails />
              </Layout>
            }
          />
        </Route>
        <Route
          path="/traceability/:id"
          element={
            <TraceApp>
              <HomePage />
            </TraceApp>
          }
        />
        <Route
          path="/traceability/:id/Farmer"
          element={
            <TraceApp>
              <FarmersDetails />
            </TraceApp>
          }
        />
        <Route
          path="/traceability/:id/:category"
          element={
            <TraceApp>
              <DetailPage />
            </TraceApp>
          }
        />
        <Route
          path="*"
          element={
            <TraceApp>
              <ErrorPage />
            </TraceApp>
          }
        />

        <Route path="/rc-form" element={<RegistrationCertificate />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/reset-password/:id" element={<ResetPassword />} />

        {/* <Route path="/offline" element={<OfflinePage/>} /> */}

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}
export default Routing;
